export default __webpack_public_path__ + "dist/media/Sent-3.88a90b8c.svg";